import { render, staticRenderFns } from "./redirect-page.vue?vue&type=template&id=12c88bd0&"
import script from "./redirect-page.vue?vue&type=script&lang=js&"
export * from "./redirect-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports